"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: google/type/dayofweek.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fgoogle%2Ftype%2Fdayofweek.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayOfWeekToJSON = exports.dayOfWeekFromJSON = exports.DayOfWeek = void 0;
/* eslint-disable */
const protobufPackage = 'google.type';
/**
 * Represents a day of the week.
 */
var DayOfWeek;
(function (DayOfWeek) {
    /**
     * DAY_OF_WEEK_UNSPECIFIED - The day of the week is unspecified.
     */
    DayOfWeek["DAY_OF_WEEK_UNSPECIFIED"] = "DAY_OF_WEEK_UNSPECIFIED";
    /**
     * MONDAY - Monday
     */
    DayOfWeek["MONDAY"] = "MONDAY";
    /**
     * TUESDAY - Tuesday
     */
    DayOfWeek["TUESDAY"] = "TUESDAY";
    /**
     * WEDNESDAY - Wednesday
     */
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    /**
     * THURSDAY - Thursday
     */
    DayOfWeek["THURSDAY"] = "THURSDAY";
    /**
     * FRIDAY - Friday
     */
    DayOfWeek["FRIDAY"] = "FRIDAY";
    /**
     * SATURDAY - Saturday
     */
    DayOfWeek["SATURDAY"] = "SATURDAY";
    /**
     * SUNDAY - Sunday
     */
    DayOfWeek["SUNDAY"] = "SUNDAY";
    DayOfWeek["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
function dayOfWeekFromJSON(object) {
    switch (object) {
        case 0:
        case 'DAY_OF_WEEK_UNSPECIFIED':
            return DayOfWeek.DAY_OF_WEEK_UNSPECIFIED;
        case 1:
        case 'MONDAY':
            return DayOfWeek.MONDAY;
        case 2:
        case 'TUESDAY':
            return DayOfWeek.TUESDAY;
        case 3:
        case 'WEDNESDAY':
            return DayOfWeek.WEDNESDAY;
        case 4:
        case 'THURSDAY':
            return DayOfWeek.THURSDAY;
        case 5:
        case 'FRIDAY':
            return DayOfWeek.FRIDAY;
        case 6:
        case 'SATURDAY':
            return DayOfWeek.SATURDAY;
        case 7:
        case 'SUNDAY':
            return DayOfWeek.SUNDAY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DayOfWeek.UNRECOGNIZED;
    }
}
exports.dayOfWeekFromJSON = dayOfWeekFromJSON;
function dayOfWeekToJSON(object) {
    switch (object) {
        case DayOfWeek.DAY_OF_WEEK_UNSPECIFIED:
            return 'DAY_OF_WEEK_UNSPECIFIED';
        case DayOfWeek.MONDAY:
            return 'MONDAY';
        case DayOfWeek.TUESDAY:
            return 'TUESDAY';
        case DayOfWeek.WEDNESDAY:
            return 'WEDNESDAY';
        case DayOfWeek.THURSDAY:
            return 'THURSDAY';
        case DayOfWeek.FRIDAY:
            return 'FRIDAY';
        case DayOfWeek.SATURDAY:
            return 'SATURDAY';
        case DayOfWeek.SUNDAY:
            return 'SUNDAY';
        case DayOfWeek.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.dayOfWeekToJSON = dayOfWeekToJSON;
//# sourceMappingURL=dayofweek.js.map